import { Link } from "react-router-dom";
import ThemeToggle from "../components/ThemeToggle";

export default function NotFound() {
    return (
        <div className="min-h-screen bg-sand-50 text-ink flex items-center justify-center px-6 py-12" data-testid="not-found-page">
            <div className="w-full max-w-md text-center">
                <div className="flex items-center justify-between">
                    <Link to="/" className="sp-overline">← Home</Link>
                    <ThemeToggle />
                </div>
                <div className="mt-16">
                    <div className="sp-overline text-ink-muted">404</div>
                    <h1 className="font-serif text-4xl mt-3">The stars can't find this page.</h1>
                    <p className="text-ink-soft mt-3">
                        The path you followed doesn't exist here. Head back to your dashboard or the landing page.
                    </p>
                    <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                        <Link to="/dashboard" className="sp-btn-primary" data-testid="not-found-dashboard">
                            Go to dashboard
                        </Link>
                        <Link to="/" className="sp-btn-ghost" data-testid="not-found-home">
                            Return home
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
